module.exports = {"652926100":"拜城镇","652926101":"铁热克镇","652926102":"察尔其镇","652926103":"赛里木镇","652926200":"黑英山乡","652926201":"克孜尔乡","652926203":"托克逊乡","652926204":"亚吐尔乡","652926205":"康其乡","652926206":"布隆乡","652926207":"米吉克乡","652926208":"温巴什乡","652926209":"大桥乡","652926210":"老虎台乡","652926400":"大宛其管理委员会","652926401":"种羊场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652926.json
// module id = 3097
// module chunks = 0